
import { firestoreDB, firebaseAuth } from '../../utils/firebase'
import { GET_PROFILE } from './actionTypes'
import { showMessageModal, hideMessageModel } from './miscActions'
import { CLIENT_ID } from '../../utils/config'
import { signOut } from './userActions'

export const getProfile=(id)=> dispatch =>{
  firestoreDB.collection('profiles').doc(id).onSnapshot(function(doc){
    if(doc.data() !== undefined){
      dispatch({
        type: GET_PROFILE,
        payload: doc.data()
      })
    }    
  })
}

export const saveProfile=(id, email, data, history)=>dispatch=>{
  const { name, adress, phone, houseNum, regio } = data
  if(name && adress && houseNum && phone && regio ){
    firestoreDB.collection('profiles').doc(id).set({
      name,
      adress,
      phone, 
      houseNum,
      regio,
      email,
      id
    }, { merge: true }).then(function(){
      const feeback = {
        type: 'success',
        txt: 'Opslaan gelukt'
      }
      dispatch(showMessageModal(feeback))
      dispatch(getProfile(id))
      setTimeout(()=>{
        history.push('/')
      }, 1000)
      setTimeout(()=>{
        dispatch(hideMessageModel())
      }, 900)
    })
  } else {
    const feeback = {
      type: 'warning',
      txt: 'Controleer of alle verplichte velden zijn ingevuld'
    }
    dispatch(showMessageModal(feeback))
  }
}

export const deleteProfile = (id) => dispatch => {
  const docId = id.toString().concat(CLIENT_ID)
  firestoreDB.collection('carts').doc(docId).delete().then(function(){
    firestoreDB.collection('profiles').doc(id).delete().then(function(){
      firebaseAuth.currentUser.delete().then(function(){
        dispatch(signOut())
      })
    })
  })
}